import { useGetPreferencesQuery } from '@/store/emptyApi';
import { PaymentGatewayProvider } from '@/types/payment';

export const usePaymentGatewayProvider = () => {
  // Get idGatewayProvider from preferences
  const { data: preferences } = useGetPreferencesQuery();
  const paymentGatewayProvider = preferences!.idGatewayProvider; // config/constants.ts

  const isSolidgate = paymentGatewayProvider === PaymentGatewayProvider.Solidgate;
  const isPaycore = paymentGatewayProvider === PaymentGatewayProvider.Paycore;

  return { paymentGatewayProvider, isSolidgate, isPaycore };
};
